import React from "react";
const VisionSection = () => {
  return (
    <section className="relative py-16 px-4 bg-gradient-to-br from-blue-50 via-white to-purple-50 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
      </div>
      <div className="relative max-w-7xl mx-auto">
        <div className="bg-white/80 backdrop-blur-xl rounded-4xl shadow-2xl overflow-hidden border border-white/20">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-1/2 p-8 lg:p-12 bg-gradient-to-br from-blue-600 to-purple-700 text-white relative overflow-hidden group">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-32 translate-x-32 group-hover:scale-150 transition-transform duration-1000"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-24 -translate-x-24 group-hover:scale-150 transition-transform duration-1000 delay-300"></div>
              <div className="relative">
                <svg className="w-16 h-16 text-white/20 absolute -top-4 -left-4" fill="currentColor" viewBox="0 0 32 32">
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
                
                <h2 className="text-4xl lg:text-5xl font-bold mb-6 relative">
                  Our Vision
                </h2>
              </div>
              <div className="relative mb-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur flex items-center justify-center border-2 border-white/30">
                    <span className="text-2xl font-bold text-white">APJ</span>
                  </div>
                  <div>
                    <p className="text-white/80 text-xs">Inspired by</p>
                    <p className="text-lg font-semibold">Atal Bihari Vajpayee</p>
                    <p className="text-white/70 text-xs">"Missile Man of India"</p>
                  </div>
                </div>
                <div className="relative pl-4 border-l-4 border-white/30">
                  <p className="text-base leading-relaxed">
                    <span className="text-3xl font-serif text-white/50 float-left mr-1">"</span>
                    Like our former president Dr. A.P.J. Abdul Kalam, it is our wishful thinking to visualize 
                    <span className="font-semibold bg-white/20 px-1.5 mx-0.5 rounded">100% literacy</span> 
                    in the nation by 2025 by fulfilling our sacred duty of providing a platform which is very essential and aims at multi-dimensional objectives to take youngsters to glorious heights in different fields and transforming them into tomorrow's entrepreneurs who will be proficient in their respective fields.
                    <span className="text-3xl font-serif text-white/50 float-right ml-1">"</span>
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-3 mt-6">
                <div className="text-center">
                  <div className="text-2xl font-bold">100%</div>
                  <div className="text-xs text-white/80">Literacy Goal</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold">2025</div>
                  <div className="text-xs text-white/80">Target Year</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold">∞</div>
                  <div className="text-xs text-white/80">Opportunities</div>
                </div>
              </div>
              <button className="mt-6 group inline-flex items-center gap-2 px-6 py-3 bg-white text-blue-600 rounded-full font-medium text-sm hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
                <span>Read Kalam's Vision</span>
                <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </div>
            <div className="lg:w-1/2 p-8 lg:p-12 bg-white">
              <div className="mb-6">
                <span className="text-xs font-semibold text-blue-600 uppercase tracking-wider">Welcome to</span>
                <h2 className="text-4xl lg:text-5xl font-bold mt-1">
                  <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                    RDS College
                  </span>
                </h2>
              </div>
              <div className="relative mb-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  Where pioneering spirit meets{" "}
                  <span className="relative inline-block">
                    <span className="relative z-10 font-semibold text-transparent bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text">
                      21st century technology
                    </span>
                    <span className="absolute bottom-1 left-0 w-full h-2 bg-gradient-to-r from-blue-200 to-purple-200 -z-0 rounded-full"></span>
                  </span>
                </p>
              </div>
              <div className="mb-8">
                <h3 className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
                  <span className="w-6 h-0.5 bg-gradient-to-r from-blue-600 to-purple-600"></span>
                  EXCELLENCE IN
                </h3>
                <div className="grid grid-cols-2 gap-3">
                  <div className="group bg-gradient-to-br from-blue-50 to-blue-100/50 p-4 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                    <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                      </svg>
                    </div>
                    <h4 className="font-semibold text-gray-800 text-sm">Renowned Faculty</h4>
                    <p className="text-xs text-gray-600">Learn from the best</p>
                  </div>
                  <div className="group bg-gradient-to-br from-purple-50 to-purple-100/50 p-4 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                    <div className="w-8 h-8 bg-purple-500 rounded-lg flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
                      </svg>
                    </div>
                    <h4 className="font-semibold text-gray-800 text-sm">Unlimited Learning</h4>
                    <p className="text-xs text-gray-600">Endless opportunities</p>
                  </div>
                  <div className="group bg-gradient-to-br from-pink-50 to-pink-100/50 p-4 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                    <div className="w-8 h-8 bg-pink-500 rounded-lg flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                      </svg>
                    </div>
                    <h4 className="font-semibold text-gray-800 text-sm">Vibrant Student Life</h4>
                    <p className="text-xs text-gray-600">50+ clubs & activities</p>
                  </div>
                  <div className="group bg-gradient-to-br from-indigo-50 to-indigo-100/50 p-4 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                    <div className="w-8 h-8 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-lg flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <h4 className="font-semibold text-gray-800 text-sm">New Ideas</h4>
                    <p className="text-xs text-gray-600">Shape the world</p>
                  </div>
                </div>
                <div className="mt-4 p-3 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl">
                  <p className="text-gray-700 text-sm italic">
                    "New Ideas to generate and new shape to the world."
                  </p>
                </div>
              </div>
              <button className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 text-white rounded-xl font-medium text-sm hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
                <span>Discover RDS College</span>
                <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
              <div className="flex gap-2 mt-4">
                <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse"></div>
                <div className="w-2 h-2 rounded-full bg-purple-400 animate-pulse delay-100"></div>
                <div className="w-2 h-2 rounded-full bg-pink-400 animate-pulse delay-200"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;